var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navContainer"},[_c('a',{attrs:{"href":"./stake"}},[_c('van-button',{attrs:{"type":"info"}},[_vm._v("质押")])],1),_c('a',{attrs:{"href":"./stakingCode"}},[_c('van-button',{attrs:{"type":"info"}},[_vm._v("质押码管理")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }